import { style } from "@mui/system";
import FadeIn from "react-fade-in";
import Lottie from "react-lottie";
import * as loadingData from "./Loading.json";

function LoadingComponent ({width=140, height=140}){
  // alert(0)
  return (
    <FadeIn>
      <div style={{ display: "flex" }}>
        <Lottie 
          options={{
          loop: true,
          autoplay: true,
          animationData: loadingData.default,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
          }
        }}
        height={height} 
        isClickToPauseDisabled={true}
        width={width} 
        />
      </div>
    </FadeIn>
  )
}
export default LoadingComponent